import { render, staticRenderFns } from "./PartnerDetail.vue?vue&type=template&id=29de7d37&"
import script from "./PartnerDetail.vue?vue&type=script&lang=ts&"
export * from "./PartnerDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports